'use client';

import { c as _c } from "react/compiler-runtime";
import { EyeIcon, PencilSquareIcon } from '@heroicons/react/24/outline';
import type React from 'react';
import { useCallback, useState } from 'react';
import { cn } from '../../../../../../shared/cn';
import { Button } from '../../../../../actions/Button';
import { ManageAttachments, ViewAttachments } from '../../Attachments';
import type { AttachmentFile } from '../../Attachments/types';
type SingleViewEditorProps = {
  editorReady: boolean;
  EditorSection: React.ReactNode;
  PreviewSection: React.ReactNode;
  height?: number;
  children?: React.ReactNode;
  markdownOnly?: boolean;
  files?: AttachmentFile[];
  setFiles?: (files: AttachmentFile[]) => void;
  disabled?: boolean;
  small?: boolean;
  syncScroll?: {
    computePosition: () => void;
    getCurrentEditorScrollPosition: () => number;
    getCurrentPreviewScrollPosition: () => number;
    syncToPreview: (scrollTop: number) => void;
    syncToEditor: (scrollTop: number) => void;
  };
};
export const SingleViewEditor = t0 => {
  const $ = _c(43);
  const {
    editorReady,
    EditorSection,
    PreviewSection,
    height,
    markdownOnly: t1,
    files: t2,
    setFiles,
    disabled: t3,
    small: t4,
    syncScroll
  } = t0;
  const markdownOnly = t1 === undefined ? false : t1;
  let t5;
  if ($[0] !== t2) {
    t5 = t2 === undefined ? [] : t2;
    $[0] = t2;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const files = t5;
  const disabled = t3 === undefined ? false : t3;
  const small = t4 === undefined ? false : t4;
  const [showPreview, setShowPreview] = useState(false);
  let t6;
  if ($[2] !== showPreview || $[3] !== syncScroll) {
    t6 = () => {
      if (!syncScroll) {
        setShowPreview(_temp);
        return;
      }
      if (showPreview) {
        syncScroll.computePosition();
        const previewScrollPos = syncScroll.getCurrentPreviewScrollPosition();
        setShowPreview(false);
        requestAnimationFrame(() => syncScroll.syncToEditor(previewScrollPos));
      } else {
        const editorScrollPos = syncScroll.getCurrentEditorScrollPosition();
        setShowPreview(true);
        requestAnimationFrame(() => syncScroll.syncToPreview(editorScrollPos));
      }
    };
    $[2] = showPreview;
    $[3] = syncScroll;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const handleToggleView = t6;
  const t7 = `${height}rem`;
  let t8;
  if ($[5] !== t7) {
    t8 = {
      minHeight: t7
    };
    $[5] = t7;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  const t9 = !editorReady && "pointer-events-none opacity-0";
  let t10;
  if ($[7] !== t9) {
    t10 = cn(t9, "bg-backgroundSecondary border-borderPrimary h-full flex-1 rounded-lg border opacity-100 transition-opacity duration-150");
    $[7] = t9;
    $[8] = t10;
  } else {
    t10 = $[8];
  }
  const t11 = `${height}rem`;
  let t12;
  if ($[9] !== t11) {
    t12 = {
      height: t11
    };
    $[9] = t11;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] !== handleToggleView || $[12] !== showPreview || $[13] !== small) {
    t13 = small ? <button type="button" onClick={handleToggleView} className="absolute top-[-20] right-2 z-10">{showPreview ? <PencilSquareIcon className="h-4.5 w-4.5" /> : <EyeIcon className="h-4.5 w-4.5" />}</button> : <section className="flex h-12 items-center justify-end rounded-t-lg border-borderPrimary border-b bg-backgroundTertiary px-3"><Button size="sm" onClick={handleToggleView}>{showPreview ? "Wr\xF3\u0107 do edycji" : "Podgl\u0105d"}</Button></section>;
    $[11] = handleToggleView;
    $[12] = showPreview;
    $[13] = small;
    $[14] = t13;
  } else {
    t13 = $[14];
  }
  const t14 = showPreview && "hidden";
  let t15;
  if ($[15] !== t14) {
    t15 = cn(t14, "h-full bg-backgroundSecondary rounded-lg");
    $[15] = t14;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== EditorSection || $[18] !== t15) {
    t16 = <div className={t15}>{EditorSection}</div>;
    $[17] = EditorSection;
    $[18] = t15;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const t17 = !showPreview && "hidden";
  let t18;
  if ($[20] !== t17) {
    t18 = cn(t17, "h-full bg-backgroundSecondary rounded-lg");
    $[20] = t17;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] !== PreviewSection || $[23] !== t18) {
    t19 = <div className={t18}>{PreviewSection}</div>;
    $[22] = PreviewSection;
    $[23] = t18;
    $[24] = t19;
  } else {
    t19 = $[24];
  }
  let t20;
  if ($[25] !== t16 || $[26] !== t19) {
    t20 = <div className="h-[calc(100%-3rem)]">{t16}{t19}</div>;
    $[25] = t16;
    $[26] = t19;
    $[27] = t20;
  } else {
    t20 = $[27];
  }
  let t21;
  if ($[28] !== t10 || $[29] !== t12 || $[30] !== t13 || $[31] !== t20) {
    t21 = <div className={t10} style={t12} suppressHydrationWarning={true}>{t13}{t20}</div>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t13;
    $[31] = t20;
    $[32] = t21;
  } else {
    t21 = $[32];
  }
  let t22;
  if ($[33] !== disabled || $[34] !== files || $[35] !== markdownOnly || $[36] !== setFiles || $[37] !== showPreview) {
    t22 = !markdownOnly && setFiles ? <>{showPreview ? <ViewAttachments files={files} /> : null}{!showPreview ? <ManageAttachments files={files} setFiles={setFiles} disabled={disabled} /> : null}</> : null;
    $[33] = disabled;
    $[34] = files;
    $[35] = markdownOnly;
    $[36] = setFiles;
    $[37] = showPreview;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t21 || $[40] !== t22 || $[41] !== t8) {
    t23 = <main className="relative w-full space-y-2" style={t8} suppressHydrationWarning={true}>{t21}{t22}</main>;
    $[39] = t21;
    $[40] = t22;
    $[41] = t8;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  return t23;
};
function _temp(prev) {
  return !prev;
}